import { storage } from '@/utils'

export default {
  setAuthorization(state, token) {
    // console.log(token)
    state.authorization = token
    try {
      storage.setLocalData('AB_AUTHORIZATION', token, 604700)
    } catch (e) {}
  },
  setNickname(state, nickname) {
    // console.log(nickname)
    state.nickname = nickname
    try {
      storage.setLocalData('AB_NICKNAME', nickname, 604700)
    } catch (e) {}
  },
  setMobile(state, mobile) {
    // console.log(mobile)
    state.mobile = mobile
    try {
      storage.setLocalData('AB_MOBILE', mobile, 604700)
    } catch (e) {}
  },
  setOpenid(state, openid) {
    // console.log(openid)
    state.openid = openid
    try {
      storage.setLocalData('AB_OPENID', openid, 604700)
    } catch (e) {}
  },
  setUnionid(state, unionid) {
    // console.log(unionid)
    state.unionid = unionid
  },
  setHeadimgurl(state, headimgurl) {
    // console.log(headimgurl)
    state.headimgurl = headimgurl
  },
  setHeadimgurl(state, headimgurl) {
    // console.log(headimgurl)
    state.headimgurl = headimgurl
  },
  setProvince(state, province) {
    // console.log(province)
    state.province = province
  },
  setCity(state, city) {
    // console.log(city)
    state.city = city
  },
  setCountry(state, country) {
    // console.log(country)
    state.country = country
  },
  setSex(state, sex) {
    // console.log(sex)
    state.sex = sex
  },
  setLanguage(state, language) {
    // console.log(language)
    state.language = language
  },
  setCode(state, code) {
    state.code = code
  },
  removeAuthorization(state) {
    state.authorization = ''
    try {
      storage.removeLocalData('AB_AUTHORIZATION')
    } catch (e) {}
  },
  removeNickname(state) {
    state.nickname = ''
    try {
      storage.removeLocalData('AB_NICKNAME')
    } catch (e) {}
  },
  removeMobile(state) {
    state.mobile = ''
    try {
      storage.removeLocalData('AB_MOBILE')
    } catch (e) {}
  },
  removeOpenid(state) {
    state.openid = ''
    try {
      storage.removeLocalData('AB_OPENID')
    } catch (e) {}
  },
  getCitiesList(state, list) {
    // console.log(list)
    state.citiesList = list
  },
  getCities(state, list) {
    // console.log(list)
    state.cities = list
  },
  changeCity(state, city) {
    // console.log(city)
    state.currentCity = JSON.parse(city)
    try {
      storage.setLocalData('AB_CURRENTCITY', city)
    } catch (e) {}
  },
  setProjectCreate(state, data) {
    state.projectCreate = data
    try {
      storage.setLocalData('AB_PROJECTCREATE', data, 604700)
    } catch (e) {}
  },
  removeProjectCreate(state) {
    state.projectCreate = {}
    try {
      storage.removeLocalData('AB_PROJECTCREATE')
    } catch (e) {}
  },
  setRebuildCreate(state, data) {
    state.rebuildCreate = data
    try {
      storage.setLocalData('AB_REBUILDCREATE', data, 604700)
    } catch (e) {}
  },
  removeRebuildCreate(state) {
    state.rebuildCreate = {}
    try {
      storage.removeLocalData('AB_REBUILDCREATE')
    } catch (e) {}
  },
  setShowLoading(state, data) {
    state.showLoading = data
  },
  setShowVoteSuccess(state, data) {
    state.showVoteSuccess = data
  },
  setFundingNewProjectCreate(state, data) {
    state.fundingNewProjectCreate = data
    try {
      storage.setLocalData('AB_FUNDINGNEW_PROJECTCREATE', JSON.stringify(data), 604700)
    } catch (e) {}
  },
  removeFundingNewProjectCreate(state) {
    state.fundingNewProjectCreate = {}
    try {
      storage.removeLocalData('AB_FUNDINGNEW_PROJECTCREATE')
    } catch (e) {}
  },
  setProfileVisitCount(state, data) {
    state.profileVisitCount = data
    try {
      storage.setLocalData('AB_PROFILEVISITCOUNT', data, 604700)
    } catch (e) {}
  },
  setCampaign(state, data) {
    state.campaign = data
    try {
      storage.setLocalData('AB_CAMPAIGN', data, 604700)
    } catch (e) {}
  },
  setChannel(state, data) {
    state.channel = data
    try {
      storage.setLocalData('AB_CHANNEL', data, 604700)
    } catch (e) {}
  },
  setAccessId(state, data) {
    state.access_id = data
    try {
      storage.setLocalData('AB_ACCESSID', data, 604700)
    } catch (e) {}
  },
  setActivityId(state, data) {
    state.activity_id = data
    try {
      storage.setLocalData('AB_ACTIVITYID', data, 604700)
    } catch (e) {}
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js